import React from "react";

import { faBalanceScaleRight } from "@fortawesome/pro-solid-svg-icons";
import { Grid } from "@material-ui/core";
import { getIn, useFormikContext } from "formik";
import { useSelector } from "react-redux";

import { Warning } from "components/ErrorMessage";
import {
  Input,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";
import { Row } from "components/Layout";
import { Paper } from "components/Paper";
import { MediumText as Heading } from "components/Text";

import {
  selectDeploymentBreedsByDeploymentIdLookup,
  selectDeploymentIdByConsignmentIdLookup,
} from "selectors";

import { useFieldValue } from "hooks";

import { Error, Icon } from "./components";
import { withAttributeNamespace } from "./util";

interface BreedSectionProps {
  errorMessage?: React.JSX.Element | null;
  children?: React.ReactNode;
  showFullDrafting?: boolean;
  onChangeBreed?: (value: string | number | null) => void;
  namespace?: string;
  readOnly?: boolean;
}

export const BreedSection = ({
  errorMessage,
  children,
  showFullDrafting,
  onChangeBreed,
  namespace,
  readOnly,
}: BreedSectionProps): React.JSX.Element => {
  const { errors } = useFormikContext();

  const advancedBreedErrors = getIn(
    errors,
    withNamespace(namespace, "advancedBreed"),
  );

  const consignmentId = useFieldValue(
    withNamespace(namespace, "consignment_id"),
  );

  const deploymentId = useSelector(selectDeploymentIdByConsignmentIdLookup)[
    consignmentId
  ];

  const breedOptions = useSelector(selectDeploymentBreedsByDeploymentIdLookup)[
    deploymentId
  ];

  if (showFullDrafting) {
    return (
      <Grid item xs={12}>
        <Paper>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Row flexGrow>
                <Icon icon={faBalanceScaleRight} color="gray44" />
                <Heading>Breed (hd)</Heading>
                <Warning>{advancedBreedErrors}</Warning>
                {errorMessage && <Error>{errorMessage}</Error>}
              </Row>
            </Grid>

            {[1, 2, 3].map(i => (
              <React.Fragment key={`br-${i}`}>
                <Grid item xs={9} sm={6}>
                  <SelectField
                    label="Breed"
                    name={withAttributeNamespace(
                      `advancedBreed${i}Id`,
                      namespace,
                    )}
                    options={breedOptions}
                    isClearable
                    onChangeExtra={i === 1 && onChangeBreed}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Input
                    label="Hd"
                    name={withAttributeNamespace(
                      `advancedBreed${i}Hd`,
                      namespace,
                    )}
                    type="number"
                    disabled={readOnly}
                  />
                </Grid>
              </React.Fragment>
            ))}
            {children}
          </Grid>
        </Paper>
      </Grid>
    );
  } else {
    return (
      <Grid item xs={12}>
        <Paper>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Row flexGrow>
                <Icon icon={faBalanceScaleRight} color="gray44" />
                <Heading>Breed</Heading>
                <Warning>{advancedBreedErrors}</Warning>
                {errorMessage && <Error>{errorMessage}</Error>}
              </Row>
            </Grid>
            {children}
          </Grid>
        </Paper>
      </Grid>
    );
  }
};
